var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pre',{staticStyle:{"padding":"20px"}},[_vm._v("    "+_vm._s(_vm.versionInfo)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }